import { css } from '@emotion/css';

const getAutoWidthInputStyles = (characters: number) => css`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  width: ${characters}ch;
  min-width: 2ch;
`;

export default getAutoWidthInputStyles;
